import { render, staticRenderFns } from "./generic.vue?vue&type=template&id=cb3e644c&"
import script from "./generic.vue?vue&type=script&lang=js&"
export * from "./generic.vue?vue&type=script&lang=js&"
import style0 from "./generic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports